import { Link } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { Button, IconChevronRight, IconOfferOutline, tokens } from '@fhs/ui';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';
import { OFFERS_AND_PROMOS_LINK } from '@fhs-legacy/frontend/src/utils/test-ids';

export function CartOffersAndPromosSections() {
  return (
    <Link href={routes.rewardsTabOffers} asChild dismissTo style={{ paddingHorizontal: 16 }}>
      <Button
        testID={OFFERS_AND_PROMOS_LINK}
        type="unstyled"
        borderRadius={0}
        style={styles.button}
        accessibilityRole="button"
        accessibilityLabel="View offers and promo codes"
        accessibilityHint="Navigates to the offers and promo codes page"
      >
        <View style={styles.iconContainer} accessibilityRole="none" accessibilityElementsHidden>
          <IconOfferOutline size={24} />
        </View>
        <Button.Text style={styles.text}>Offers & Promos Codes</Button.Text>
        <IconChevronRight size={24} accessibilityRole="none" accessibilityElementsHidden />
      </Button>
    </Link>
  );
}

const styles = StyleSheet.create({
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$blackOpacity04,
    borderRadius: 999,
    height: 40,
    width: 40,
  },
  text: {
    fontWeight: '300',
    flex: 1,
  },

  button: {
    justifyContent: 'flex-start',
    padding: 16,
    height: 72,
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: tokens.colors.$blackOpacity04,
    borderRadius: 0,
  },
});
